import axios
	from "axios"
import store
	from "./../../globals"
import _
	from "lodash"

import {isNotEmpty, currency, removeRecords}
	from "./../../common"

const API_URL      = process.env.REACT_APP_API_URL
const RESOURCE_URL = process.env.REACT_APP_API_URL + "/admin/campus/"

class CourseLevelsService
{
	sessionToken = store.getState().sessionToken.value
	campusId     = store.getState().currentUserCampusId.value
	constructor()
	{
		store.subscribe
		(
			()=>
			{
				this.sessionToken = store.getState().sessionToken.value
				this.campusId     = store.getState().currentUserCampusId.value
			}
		)
	}
	async searchLevels(search? : any, expand? : boolean, page? : number)
	{
		let params = [];

		if(page)
		{
			params.push("page=" + page)
		}

		if(search)
		{
			if(search.statusId >= 0)
			{
				params.push("statusId=" + search.statusId)
			}
			if(search.levelStatusId >= 0)
			{
				params.push("levelStatusId=" + search.levelStatusId)
			}
			if(search.categoryId > 0)
			{
				params.push("categoryId=" + search.categoryId)
			}
			if(isNotEmpty(search.mentors))
			{
				params.push("mentorIds=" + _.map(search.mentors, "id").join(","))
			}
			if(isNotEmpty(search.courses))
			{
				params.push("courseIds=" + _.map(search.courses, "id").join(","))
			}
			if(isNotEmpty(search.tags))
			{
				params.push("tagIds=" + _.map(search.tags, "id").join(","))
			}
			if(isNotEmpty(search.mentorRef))
			{
				params.push("mentorIds=" + _.map(Object.values(search.mentorRef), "id").join(","))
			}
		}
		if(isNotEmpty(search?.q))
		{
			params.push("q=" + search.q)
		}
		if(expand)
		{
			params.push("expand")
		}
		return axios.get
		(
			RESOURCE_URL + this.campusId + "/levels" + (params.length > 0 ? "?" + params.join("&") : ""),
			{
				headers:
				{
					"Content-Type" : "application/json",
					Authorization  : "Bearer " + this.sessionToken
				}
			}
		)
		.then
		(
			response=>
			{
				return response;
			}
		)
	}

	saveLevel(selectedLevel : any, editedLevel : any, mentorProcedures : any, kitProcedures : any, assignmentRefs : any)
	{
		const saveFunction = editedLevel.id == null ? this.registerLevel : this.updateLevel
		let record : any=
		{
			courseId        : editedLevel.course_id,
			name            : editedLevel.name,
			code            : editedLevel.code,
			statusId        : editedLevel.status_id,
			sessionMinHours : editedLevel.session_min_hours,
			weekHours       : editedLevel.week_hours,
			weekMinDays     : editedLevel.week_min_days,
			weekMaxDays     : editedLevel.week_max_days,
			mentors         : mentorProcedures,
			kits            : kitProcedures,
			assignments     : assignmentRefs
		}
		switch((store.getState().campusRef.value)["C_" + this.campusId].company.currency_id)
		{
			case currency.MXN:
				record.subscriptionBasePriceMXN           = editedLevel.subscription_base_price_mxn
				record.monthlyBillingBasePriceMXN         = editedLevel.monthly_billing_base_price_mxn
				record.subscriptionSurchargeBaseCostMXN   = editedLevel.subscription_surcharge_base_cost_mxn
				record.monthlyBillingSurchargeBaseCostMXN = editedLevel.monthly_billing_surcharge_base_cost_mxn
				record.secondSurchargeBaseCostMXN         = editedLevel.second_surcharge_base_cost_mxn
			break;
			case currency.HNL:
				record.subscriptionBasePriceHNL           = editedLevel.subscription_base_price_hnl
				record.monthlyBillingBasePriceHNL         = editedLevel.monthly_billing_base_price_hnl
				record.subscriptionSurchargeBaseCostHNL   = editedLevel.subscription_surcharge_base_cost_hnl
				record.monthlyBillingSurchargeBaseCostHNL = editedLevel.monthly_billing_surcharge_base_cost_hnl
				record.secondSurchargeBaseCostHNL         = editedLevel.second_surcharge_base_cost_hnl
			break;
			case currency.USD:
				record.subscriptionBasePriceUSD           = editedLevel.subscription_base_price_usd
				record.monthlyBillingBasePriceUSD         = editedLevel.monthly_billing_base_price_usd
				record.subscriptionSurchargeBaseCostUSD   = editedLevel.subscription_surcharge_base_cost_usd
				record.monthlyBillingSurchargeBaseCostUSD = editedLevel.monthly_billing_surcharge_base_cost_usd
				record.secondSurchargeBaseCostUSD         = editedLevel.second_surcharge_base_cost_usd
			break;
		}
		if(isNotEmpty(editedLevel.description))
		{
			record.description = editedLevel.description
		}
		return saveFunction
		(
			selectedLevel.course_id, record,
			{
				headers:
				{
					"Content-Type" : "application/json",
					Authorization  : "Bearer " + this.sessionToken
				}
			},
			editedLevel.id
		)
	}
	async registerLevel(courseId : number, registry : any, options : any)
	{
		return axios.post
		(
			RESOURCE_URL + store.getState().currentUserCampusId.value + "/courses/" + courseId + "/levels",
			registry,
			options
		)
		.then
		(
			response=>
			{
				return response;
	}
		)
	}

	async updateLevel(courseId : number, registry : any, options : any, id : number)
	{
		return axios.put
		(
			RESOURCE_URL + store.getState().currentUserCampusId.value + "/courses/" + courseId + "/levels/" + id,
			registry,
			options
		)
		.then
		(
			response=>
			{
				return response;
			}
		)
	}

	async removeLevels(campusId : number, recordIds? : any)
	{
		return removeRecords(RESOURCE_URL + this.campusId + "/levels", recordIds)
	}
}

export default new CourseLevelsService()